<button *ngIf="!isLoginPage()" (click)="toggleMenu()" class="menu-toggle-btn">
  <i class="fas fa-bars"></i>
</button>
<app-menu *ngIf="!isLoginPage()"></app-menu>
<div class="content" [class.menu-open]="(isMenuOpen$ | async) && !isLoginPage()" [class.full-width]="isLoginPage()">
  <router-outlet></router-outlet>
</div>

<p-toast></p-toast>
